/* @ngInject */
export default function ZoneSelectionRectService(ZoneSelectionStore) {
  const service = this;
  const viewMax = 100;
  const allowResize = {
    0: false,
    1: false,
    2: false,
    3: false
  };

  let svgReadyToDrag = false;
  let boxReadyToDrag = false;
  let resizeReadyToDrag = false;

  let tempUpperLeftX;
  let tempUpperLeftY;
  let widthPoint;
  let heightPoint;

  let target;

  let resizeInd;

  service.state = ZoneSelectionStore.state;

  const coords = service.state.rectCoords;

  service.assignRectActiveZone = assignRectActiveZone;
  service.assignDetectionSizeOrToggle = assignDetectionSizeOrToggle;
  service.getRectCoordinates = getRectCoordinates;
  service.getDetectionBoxPercentage = getDetectionBoxPercentage;
  service.enableRectCreation = enableRectCreation;
  service.createDragOrResizeRect = createDragOrResizeRect;
  service.alterRectDimensions = alterRectDimensions;
  service.cancelRectInteraction = cancelRectInteraction;
  service.enableRectDrag = enableRectDrag;
  service.enableResizeAtPoint = enableResizeAtPoint;

  function assignRectActiveZone(zoneCords) {
    service.state.vmd = false;
    const zCoords = angular.copy(zoneCords);
    coords.upperLeftX = zCoords.x;
    coords.upperLeftY = zCoords.y;
    coords.boxWidth = zCoords.x2 - zCoords.x;
    coords.boxHeight = zCoords.y2 - zCoords.y;

    service.state.enabled = true;
    service.state.enableRectShadow = true;
    service.state.renderSquares = true;
    service.state.enableRectSelector = true;
    service.state.enableResizeGroup = true;
  }

  function assignDetectionSizeOrToggle(toggle = false, percents) {
    if (percents) {
      const [widthP, heightP] = percents;
      service.state.detectionSize.upperLeftX = 0;
      service.state.detectionSize.upperLeftY = 0;
      service.state.detectionSize.boxWidth = widthP;
      service.state.detectionSize.boxHeight = heightP;
    }
    if (toggle) {
      service.state.showDetectionSize = !service.state.showDetectionSize;
      service.state.enableRectShadow = !service.state.vmd && service.state.rectCoords.boxWidth;
      service.state.enableRectSelector =
          !service.state.vmd && service.state.rectCoords.boxWidth && !service.state.showDetectionSize;
      service.enableResizeGroup =
          !service.state.vmd && service.state.renderSquares && !service.state.showDetectionSize;
    }
  }

  function getRectCoordinates() {
    return {
      x: coords.upperLeftX,
      y: coords.upperLeftY,
      x2: coords.upperLeftX + coords.boxWidth,
      y2: coords.upperLeftY + coords.boxHeight
    };
  }

  function getDetectionBoxPercentage() {
    return [service.state.detectionSize.boxWidth, service.state.detectionSize.boxHeight];
  }

  function enableRectCreation(evt) {
    evt.stopPropagation();
    evt.preventDefault();
    const cursorpt = cursorPoint(evt);
    svgReadyToDrag = true;
    tempUpperLeftX = cursorpt.x;
    tempUpperLeftY = cursorpt.y;

  }

  function createDragOrResizeRect(evt) {
    if (svgReadyToDrag) {

      const cursorpt = cursorPoint(evt);
      const x = cursorpt.x;
      const y = cursorpt.y;
      alterRectDimensions(x, y, tempUpperLeftX, tempUpperLeftY, coords);
    }

    if (boxReadyToDrag) {
      moveRect(evt);
    }

    if (resizeReadyToDrag) {
      resizeAtPoint(evt);
    }
  }

  function alterRectDimensions(x, y, tempX, tempY, dimensions) {
    if (x > tempX) {
      dimensions.upperLeftX = tempX;
      dimensions.boxWidth = x - dimensions.upperLeftX;

    } else {
      dimensions.upperLeftX = x;
      dimensions.boxWidth = tempX - x;
    }
    if (y > tempY) {
      dimensions.upperLeftY = tempY;
      dimensions.boxHeight = y - dimensions.upperLeftY;
    } else {
      dimensions.upperLeftY = y;
      dimensions.boxHeight = tempY - y;
    }
  }

  function cancelRectInteraction() {
    svgReadyToDrag = false;
    boxReadyToDrag = false;
    resizeReadyToDrag = false;
    allowResize[resizeInd] = false;
    service.state.renderSquares = true;
    target = null;
  }

  function enableRectDrag(evt, detectBox) {
    evt.stopPropagation();
    boxReadyToDrag = true;
    target = detectBox ? service.state.detectionSize : coords;
  }

  function moveRect(evt) {
    if (boxReadyToDrag) {
      const halfWidth = target.boxWidth / 2;
      const halfHeight = target.boxHeight / 2;
      const { x, y } = cursorPoint(evt);
      if (x + halfWidth <= viewMax && x >= halfWidth) {
        target.upperLeftX = x - halfWidth;
      }
      if (y + halfHeight <= viewMax && y >= halfHeight) {
        target.upperLeftY = y - halfHeight;
      }
    }
  }

  function enableResizeAtPoint(evt, ind, detectBox) {
    evt.stopPropagation();
    target = detectBox ? service.state.detectionSize : coords;
    resizeReadyToDrag = true;
    const cursorpt = cursorPoint(evt);
    tempUpperLeftX = cursorpt.x;
    tempUpperLeftY = cursorpt.y;
    widthPoint = target.boxWidth + tempUpperLeftX;
    heightPoint = target.boxHeight + tempUpperLeftY;
    allowResize[ind] = true;
    resizeInd = ind;
  }

  function resizeAtPoint(evt) {
    if (allowResize[resizeInd]) {
      const cursorpt = cursorPoint(evt);
      const x = cursorpt.x;
      const y = cursorpt.y;
      const forZoneBox = target === coords;
      switch (resizeInd) {
        case 0:
          if (widthPoint - x > 1) {
            target.upperLeftX = x;
            target.boxWidth = widthPoint - x;
          }
          if (heightPoint - y > 1) {
            target.upperLeftY = y;
            target.boxHeight = heightPoint - y;
          }
          break;
        case 1:
          if (x - target.upperLeftX > 1) {
            target.boxWidth = x - target.upperLeftX;
          }
          if (heightPoint - y > 1) {
            target.upperLeftY = y;
            target.boxHeight = heightPoint - y;
          }
          break;
        case 2:
          if (forZoneBox) {
            if (x - target.upperLeftX > 1) {
              target.boxWidth = x - target.upperLeftX;
            }
            if (y - target.upperLeftY > 1) {
              target.boxHeight = y - target.upperLeftY;
            }
          } else {
            if (x - target.upperLeftX > 3) {
              target.boxWidth = Math.floor(x - target.upperLeftX);
            }
            if (y - target.upperLeftY > 3) {
              target.boxHeight = Math.floor(y - target.upperLeftY);
            }
          }
          break;
        case 3:
          if (widthPoint - x > 1) {
            target.upperLeftX = x;
            target.boxWidth = widthPoint - x;
          }
          if (y - target.upperLeftY > 1) {
            target.boxHeight = y - target.upperLeftY;
          }
          break;
        default:
            // wut r u doin m8
      }
    }
  }

  function cursorPoint(evt) {
    if (evt.type.slice(0, 5) === 'touch') {
      evt = evt.touches[0];
    }
    service.state.pt.x = evt.clientX;
    service.state.pt.y = evt.clientY;
    return service.state.pt.matrixTransform(service.state.svg.getScreenCTM().inverse());
  }
}
